import { useSelector } from 'react-redux';
import { redirectUrlSelector } from 'src/state/auth/authSelectors';
import { useEffect } from 'react';
import { isSome } from 'fp-ts/Option';
import { PostRedirectAction } from 'src/config/postRedirectAction';
import { useIsLoggedIn } from 'src/common/hooks/useIsLoggedIn';
import { useJoinElearningMutation } from 'src/common/hooks/elearning/useJoinElearningMutation';
import { Elearning } from 'src/common/models/elearning';

export const useJoinElearningAfterRedirect = (elearning?: Elearning) => {
  const redirectUrl = useSelector(redirectUrlSelector);
  const { isLoggedIn } = useIsLoggedIn();
  const mutation = useJoinElearningMutation(elearning?.id ?? 0);

  useEffect(() => {
    if (
      isLoggedIn &&
      isSome(redirectUrl) &&
      PostRedirectAction.JoinElearning === redirectUrl.value.action &&
      elearning &&
      !elearning.elearningUserEnrollment?.isEnrolled
    ) {
      mutation.mutate();
    }
  }, [redirectUrl, isLoggedIn, elearning]);

  return mutation;
};
